import { IAssociadoReducer, IAssociadoAction } from './interfaces';

const INITIAL_STATE: IAssociadoReducer = {
  parametros: null,
  parametrosIsLoading: false,
  proximosEventos: null,
  proximosEventosIsLoading: false,
  baixandoDocumento: null,
  buscandoUsuariosOnline: false,
  usuariosOnline: 0,
};

export default function associadoReducer(
  state: IAssociadoReducer = INITIAL_STATE,
  action: IAssociadoAction
): IAssociadoReducer {
  switch (action.type) {
    case 'loadindParametros':
      return { ...state, parametrosIsLoading: action.payload };
    case 'setParametros':
      return { ...state, parametros: action.payload };
    case 'setProximosEventos':
      return { ...state, proximosEventos: action.payload };
    case 'loadingProximosEventos':
      return { ...state, proximosEventosIsLoading: action.payload };
    case 'downloadingFile':
      return { ...state, baixandoDocumento: action.payload };
    case 'buscandoUsuariosOnline':
      return { ...state, buscandoUsuariosOnline: action.payload };
    case 'setUsuariosOnline':
      return { ...state, usuariosOnline: action.payload };
    default:
      return state;
  }
}
